import request from "@/plugins/axios"
//上传汇总任务
let prefix = "eids-invoice/tcs/uploadTask";

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function list(criteria) {
  return request({
    url: prefix + '/list',
    method: 'post',
    data: criteria,
  })
}
//更新任务为已完成
export function update(taskId) {
  return request({
    url: prefix + '/update/'+taskId,
    method: 'post',
  })
}
//获取登录二维码
export function getLoginCode(param) {
  return request({
    url:  'eids-invoice/tcs/login',
    method: 'post',
    data:param
  })
}


//获取登录二维码
export function executeTask(taskId) {
  return request({
    url:  'eids-invoice/tcs/login/success/'+taskId,
    method: 'get',
  })
}

